export default "__VITE_ASSET__D0TGKX9K__"